<!--
  REV-21363 — the SHARED document preview (Pure View).

  Selector contract: tests bind to `data-testid`, never to styling classes and never to translated
  prose as an anchor. See e2e-lab/document-preview.lab.spec.ts.

  EXTRACTED from `document-detail.component.html` (REV-21368) so two surfaces show one preview
  instead of two copies — the copy would have carried the security control without its tests.

  Five mutually exclusive states, precedence top to bottom. `unsupported` sits BEFORE `missing`
  because it is a statement about the FILE; `missing` is one about the LINK.
-->
<div class="dp" data-testid="document-preview-root">
    <div class="dp-loading" data-testid="document-preview-loading" *ngIf="loading">
        <div class="dp-skeleton" aria-hidden="true"></div>
    </div>

    <div class="dp-error" data-testid="document-preview-error" *ngIf="!loading && error">
        {{ 'abcp_document_preview_error' | i18next }}
    </div>

    <ng-container *ngIf="!loading && !error">
        <!-- Der browsereigene Viewer (ADR-0009 §13). Kein pdf.js, kein eigener Renderer; die
             Komponente holt die Datei nie, sie reicht nur die URL weiter. -->
        <iframe
            class="dp-frame"
            data-testid="document-preview"
            *ngIf="isEmbeddable"
            [src]="previewSrc"
            [title]="title"
        ></iframe>

        <!-- Nicht-PDF: REGULAERER Zustand, kein Fehler. Der Ingest ist PDF-only (§12), die
             Anzeige nicht — agentenerzeugte .xlsx gibt es wirklich. -->
        <div class="dp-placeholder" data-testid="document-preview-unsupported" *ngIf="isUnsupported">
            <lucide-icon name="file-text" [size]="32" aria-hidden="true"></lucide-icon>
            <div class="dp-placeholder__title">{{ 'abcp_document_preview_unsupported' | i18next }}</div>
            <div class="dp-placeholder__hint">{{ 'abcp_document_preview_unsupported_hint' | i18next }}</div>
        </div>

        <!-- PDF ohne einbettbare URL: ein ANDERER Platzhalter — die Datei ist nur noch nicht
             freigegeben (scanStatus != CLEAN) oder ihr Schema ist nicht einbettbar, nicht unlesbar. -->
        <div class="dp-placeholder" data-testid="document-preview-missing" *ngIf="isMissing">
            <lucide-icon name="clock" [size]="32" aria-hidden="true"></lucide-icon>
            <div class="dp-placeholder__title">{{ 'abcp_document_preview_missing' | i18next }}</div>
            <div class="dp-placeholder__hint">{{ 'abcp_document_preview_missing_hint' | i18next }}</div>
        </div>
    </ng-container>
</div>
